import { Component, OnInit } from "@angular/core";
import { delay, map } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../../../store/reducers";

import { selectSelectedAsset } from "../../../store/selectors/dashboard.selectors";
import { AsyncPipe, NgIf } from "@angular/common";

@Component({
  selector: "ngx-top-status-bar",
  templateUrl: "./top-status-bar.component.html",
  styleUrls: ["./top-status-bar.component.scss"],
  imports: [AsyncPipe, NgIf],
})
export class TopStatusBarComponent implements OnInit {
  public showAssetFilter$: Observable<boolean>;
  public showTimeSelector$: Observable<boolean>;
  public selectedAssetName$: Observable<string>;
  public dateRangeMinDateFormatted$: Observable<string>;
  public dateRangeMaxDateFormatted$: Observable<string>;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.showAssetFilter$ = this.store.pipe(
      delay(0),
      select((state: AppState) => {
        if (state.dashboard.selectedTab) {
          return state.dashboard.showSideMenu;
        }
        return false;
      }),
    );

    this.showTimeSelector$ = this.store.pipe(
      select((state: AppState) => state.dashboard.showTimeSelector),
    );

    this.selectedAssetName$ = this.store.pipe(
      select(selectSelectedAsset),
      map((x) => x?.name),
    );

    this.dateRangeMinDateFormatted$ = this.store.pipe(
      select((state: AppState) => state.dashboard.selectedDateRangeMin),
      map((minDate) => minDate.toLocaleString()),
    );

    this.dateRangeMaxDateFormatted$ = this.store.pipe(
      select((state: AppState) => state.dashboard.selectedDateRangeMax),
      map((maxDate) => maxDate.toLocaleString()),
    );
  }
}
